import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'conversations';

const getConversationListFromName = async ({
  page,
  limit,
  search,
  orderBy,
  selectedConversationFromName
}) => {
  const method = 'GET';
  const url =
    `${USE_CASE_URL}` +
    `?page=${page}&limit=${limit}&search=${search}&orderBy=${orderBy}&fromName=${selectedConversationFromName}`;

  const json = await request({ method, url });
  return json;
};

export default getConversationListFromName;
